/* eslint-disable no-restricted-imports */
import type ItemMetadata from 'pages/open-course/common/models/itemMetadata';

type Progress = $TSFixMe; // Progress based on pages/open-course/common/models/progress
class WiseFlowState {
  declare itemMetadata: ItemMetadata;

  declare itemProgress: Progress;

  constructor(itemMetadata: ItemMetadata, itemProgress: Progress) {
    this.itemMetadata = itemMetadata;
    this.itemProgress = itemProgress;
  }

  isCompleted(): boolean {
    return this.itemProgress.isComplete();
  }

  isSubmitted(): boolean {
    const submittedAt = this.itemProgress.getDefinition('submittedAt');
    return this.itemProgress.hasStarted() && submittedAt;
  }

  isStarted(): boolean {
    const submittedAt = this.itemProgress.getDefinition('submittedAt');
    return this.itemProgress.hasStarted() && !submittedAt;
  }
}

export default WiseFlowState;
